<script>
  import { createEventDispatcher } from 'svelte';
  import Field from '@commercebear/components/Field';
  import EmailInput from '@commercebear/components/EmailInput';
  import PasswordInput from '@commercebear/components/PasswordInput';
  import Button, { NONE } from '@commercebear/components/Button';
  import BrandButton from '$lib/components/BrandButton';
  import { preventDefault } from '$util/event';
  import Auth from '$util/auth';
  import BrandForm from '../BrandForm';

  const dispatch = createEventDispatcher();

  export let error = undefined;
  export let success = undefined;
  export let message = undefined;

  let email = '';
  let emailInvalid = false;
  function clearEmailError() {
    emailInvalid = false;
  }
  function invalidEmail() {
    emailInvalid = true;
  }

  let password = '';

  async function login() {
    error = undefined;
    success = undefined;
    message = undefined;
    try {
      await Auth.login({ email, password, persist: true });
      dispatch('login');
    } catch (requestError) {
      if (requestError?.status === 401) {
        error = 'The email / password combination you entered was invalid. Please try again or reset your password.';
      } else {
        console.error(requestError); // eslint-disable-line no-console
        error = 'An unexpected error occurred. Please try again.';
      }
    }
  }
</script>

<BrandForm method='POST' testid='login-form' {error} {message} {success}>
  <div class='fields'>
    <Field error={emailInvalid} newBrand>
      <svelte:fragment slot='label'>Email</svelte:fragment>
      <EmailInput
        name='email'
        placeholder='Email'
        on:input={clearEmailError}
        on:invalid={invalidEmail}
        bind:value={email}
        newBrand
        testid='login-email-field' />
      <svelte:fragment slot='hint'>
        {#if emailInvalid}
          Must be a valid email address.
        {/if}
      </svelte:fragment>
    </Field>

    <Field newBrand>
      <svelte:fragment slot='label'>Password</svelte:fragment>
      <div class='password-field'>
        <PasswordInput
          name='password'
          placeholder='Password'
          bind:value={password}
          newBrand
          testid='login-password-field' />
        <div class='forgot-password'>
          <Button appearance={NONE} on:click={preventDefault(() => dispatch('forgot'))} testid='forgot-password-button'>
            <span class='forgot-password-text'>Forgot Password?</span>
          </Button>
        </div>
      </div>
    </Field>

    <BrandButton primary type='submit' on:click={preventDefault(login)} testid='login-button'>
      Login
    </BrandButton>
  </div>
</BrandForm>

<style lang='postcss'>
  .fields {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .password-field {
    display: flex;
    flex-direction: column;
    gap: 4px;

    & .forgot-password {
      align-self: flex-end;

      & .forgot-password-text {
        font: var(--font--body-outfit-paragraph);
        color: var(--color--core-white);
      }
    }
  }

  @media (--screen-width--below-desktop) {
    .fields {
      --Button--flex: 1;
    }
  }

  @media (--screen-width--below-tablet) {
    .fields {
      gap: 24px;
    }
  }
</style>
